import type { FaireProductEntity } from "../../entity_types/product";

export const p_9ydkbxc542: FaireProductEntity = {
  token: "p_9ydkbxc542",
  type: "product",
  name: "Moonchild Rainbow Tee",
  brandToken: "b_d849rxmheb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/379a6952590ac7448f6eaf54383e6ae23139c532c523203226c52696623d4aef.jpeg",
  galleryImageUrls: [],
  priceDollars: 16.63,
  description:
    "Calling all free spirits and night sky dreamers—this Moonchild design is a total vibe. With earthy boho tones, a celestial rainbow, and lunar phases framing the look, it's perfect for cosmic souls who feel most at home under the stars. A must-have for moon watchers, astrology lovers, and anyone with a touch of magic in their soul. It’s effortlessly unique\n4.2 oz./yd² (US) 7 oz./L yd (CA), 100% Airlume combed and ring-spun cotton, 32 singles\nAsh is 99/1 Airlume combed and ring-spun cotton/polyester\nPre-shrunk\nRetail fit\nUnisex sizing\nCoverstitched collar and sleeves\nShoulder-to-shoulder taping\nSide seams\nTear away label\n\nBC3001 Black",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:07.244Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
